import $ from 'jquery'

export default function render_fragments(request, replace){
	if(!request) return;
	request = JSON.parse(request);
	if(!request) return;
	if(!request.fragments) return;
	$.each(request.fragments, function(key, value){
		var el = $(key);
		if(value == '__remove__'){
			el.remove();
		} else {
			if(el.is('input')){
				el.val(value)
			} else {
				if(replace){
					el.replaceWith(value)
				} else {
					el.html(value)
				}
			}
		}
	})
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/render_fragments.js